// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__4Z8ap","content":"Modal_content__uRFNc","header":"Modal_header__rdA2H","name":"Modal_name__lsjpv","close":"Modal_close__H-TeX"};